import { Button } from "@vds/buttons";
import { Row } from "@vds/grids";
import { ListItem, UnorderedList } from "@vds/lists";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import {
  Cell,
  TableHeader
} from "@vds/tables";
import { Tooltip } from "@vds/tooltips";
import { Body, Title, Micro } from "@vds/typography";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { MarginTopSpacerM} from "common/components/styleTag";


function PlansDetailsModal(props) {
  const { t } = useTranslation(["plans"]);
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });
  const planData = props?.plansData;
  return (
    <>
      <PlanDetailModal
        hideCloseButton={true}
        disableOutsideClick={true}
        onOpenedChange={(e) => {
          if (!e) {
            props.close(null);
          }
        }}
        opened={!!props.showModal}
        data-track="close"
        disableFocusLock= {true}
        zIndex={isMobile ? "1333337" : "999"}
        isFlexPlan={props?.isFlexPlan}
      >
        <ModalDeviceContainer>
          <ModalTitle>
            <Title size="medium">{props?.planTitle}</Title>
          </ModalTitle>
          <ModalBody style={{ padding: "1rem !important" }}>
            <>
              {planData?.features?.map((element, idx) => {
                return (
                  <div key={idx}>
                     {!props.isFlexPlan ? (
                      <>
                    <Body size="medium" bold>
                      <StyledSpan>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: element?.title,
                          }}
                        />
                      </StyledSpan>
                    </Body>
                    <StyledList>
                      <UnorderedList>
                        {element?.listItems?.map((item, index) => (
                          <ListItem
                            key={index}
                            size="bodyLarge"
                            spacing="compact"
                          >
                            <Body size="small">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item,
                                }}
                              />
                            </Body>
                          </ListItem>
                        ))}
                      </UnorderedList>
                        </StyledList>
                         </>
                    ) : (
                        <>
                      <UnorderedList>
                        {element?.listItems?.map((item, index) => (
                          <ListItemDiv
                            key={index}
                            size="bodyMedium"
                            spacing="compact"
                          >
                            <Body size="medium">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item,
                                }}
                              />
                            </Body>
                            <MarginTopSpacerM/>
                          </ListItemDiv>

                        ))}
                          </UnorderedList>
                           <MarginTopSpacerM/>
                          <Micro size="medium">{planData?.footer}</Micro>
                          
                        </>
                        )
                    }
                  </div>
                );
              })}
            </>
          </ModalBody>
        </ModalDeviceContainer>
      </PlanDetailModal>
    </>
  );
}

export const StyledCell = styled(Cell)`
  padding: 16px 32px 16px 12px !important;
  @media screen and (max-width: 767px) {
    padding: 12px 0px 12px 12px !important;
  }
`;

export const BgStyledCell = styled(Cell)`
  padding: 16px 32px 16px 12px !important;
  background-color: #f6f6f6;
  @media screen and (max-width: 767px) {
    padding: 12px 0px 12px 12px !important;
  }
`;

export const StyledTableHeader = styled(TableHeader)`
  padding: 16px 32px 16px 12px !important;
  @media screen and (max-width: 767px) {
    padding: 12px 0px 12px 12px !important;
  }
`;
export const BgTableHeader = styled(TableHeader)`
  padding: 16px 32px 16px 12px !important;
  background-color: #f6f6f6;
  @media screen and (max-width: 767px) {
    padding: 12px 0px 12px 12px !important;
  }
`;

export const RowNoPad = styled(Row)`
  padding: 0 !important;
`;

const PlanDetailModal = styled(Modal)`
  height: 100% !important;

  @media screen and (min-width:767px){
  padding:${({ isFlexPlan }) => (isFlexPlan ? "32px 0px 32px 32px" : "48px 0px 48px 42px")};
  }

  @media screen and (max-width: 767px) {
    width: 400px;
    height: 250px;
    z-index: 1000;
  }
  @media screen and (max-width: 480px) {
    padding: 16px 0px 0px 16px;
  }
  @media screen and (max-width: 378px) {
    padding: 16px 0px 0px 16px;
  }
`;

const StyTooltip = styled(Tooltip)`
  margin-left: -1.87rem;
  margin-top: -4px;
  height: 2rem !important;
  @media screen and (max-width: 767px) {
    margin-left: -2.18rem;
  }
  @media screen and (max-width: 380px) {
    margin-left: -0.7rem;
  }
`;
const StyledTooltip = styled(Tooltip)`
  margin-left: -1.87rem;
  margin-top: 3px;
  @media screen and (max-width: 767px) {
    margin-left: -2.18rem;
  }
  @media screen and (max-width: 380px) {
    margin-left: -0.7rem;
  }
`;
const ModalDeviceContainer = styled.div`
 height:100%;
 [class^=StyledFooter-VDS]{
    padding:0 0 48px 0 !important;
 }
}
`;
const ButtonWrapper = styled(Button)`
  bottom: 12px;
`;
const StyledSpan = styled.span`
  display: flex;
  margin-top: 10px;
`;
const StyledList = styled(UnorderedList)`
  padding-left: 20px;
  line-height: 16px;
`;

const ListItemDiv = styled(UnorderedList)`
list-style-type:none;
`;

export default PlansDetailsModal;
